var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_7917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00023 12.874H12.0002V6.87402H15.0002L10.0002 1.87402L5.00023 6.87402H8.00023V12.874ZM19.3382 14.406C19.1282 14.182 17.7272 12.683 17.3272 12.292C17.0469 12.0233 16.6735 11.8735 16.2852 11.874H14.5282L17.5922 14.868H14.0482C14.0001 14.8671 13.9525 14.879 13.9104 14.9023C13.8682 14.9257 13.833 14.9597 13.8082 15.001L12.9922 16.874H7.00822L6.19222 15.001C6.16729 14.9599 6.13202 14.9259 6.08992 14.9026C6.04782 14.8793 6.00035 14.8673 5.95223 14.868H2.40823L5.47123 11.874H3.71522C3.31822 11.874 2.93923 12.033 2.67323 12.292C2.27323 12.684 0.872225 14.183 0.662225 14.406C0.173225 14.927 -0.0957749 15.342 0.0322251 15.855L0.593225 18.929C0.721225 19.443 1.28423 19.865 1.84523 19.865H18.1572C18.7182 19.865 19.2812 19.443 19.4092 18.929L19.9702 15.855C20.0962 15.342 19.8282 14.927 19.3382 14.406Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_7917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.2370333ac496f4f7c4f52b4b0195eada.svg";
export { ForwardRef as ReactComponent };